import * as React from "react";
import { Check, Edit, FileOutput } from "lucide-react";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";
import { Loader } from "@/components/ui/loader";
import * as analytics from "@/services/analytics";

interface Props {
  content: string;
  messageId: string;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OpenChatMessageRowImprovementEditor: React.FC<Props> = ({ content, messageId, setIsEdit }) => {
  const { sendPromptToChat, isSendingToChat, sentChatMessageIds, markMessageSentToChat } = usePromptGeneratorContext();

  const wasSent = sentChatMessageIds.has(messageId);

  const handleSendToChat = () => {
    sendPromptToChat(content);
    markMessageSentToChat(messageId);
    analytics.improvePromptSendToChat(content);
  };

  const handleEdit = () => {
    setIsEdit(prev => !prev);
  };

  const isDisabled = wasSent || isSendingToChat;

  return (
    <div className="mt-1 flex justify-end gap-1">
      <button
        className="flex rounded-md bg-[#585451] p-1 text-xs text-white disabled:opacity-50"
        onClick={handleSendToChat}
        disabled={isDisabled}
      >
        {wasSent ? (
          <Check size={14} className="mr-1" />
        ) : isSendingToChat ? (
          <Loader className="mr-1 h-3.5 w-3.5" />
        ) : (
          <FileOutput size={14} className="mr-1" />
        )}
        {wasSent ? "Sent" : isSendingToChat ? "Sending..." : "Send to chat"}
      </button>
      <button className="flex rounded-md bg-[#585451] p-1 text-xs text-white" onClick={handleEdit}>
        <Edit size={14} className="mr-1" />
        Edit
      </button>
    </div>
  );
};
